import React from 'react';

const ToolLogo = ({ tool }) => {
  if (tool.component) {
    const Component = tool.component;
    return <Component size={32} />;
  }
  if (tool.emoji) return <span className="tool-emoji">{tool.emoji}</span>;
  if (tool.logoDark) return (
    <>
      <img src={tool.logo} alt={`${tool.name} logo`} className="logo-light-only" />
      <img src={tool.logoDark} alt={`${tool.name} logo`} className="logo-dark-only" />
    </>
  );
  return <img src={tool.logo} alt={`${tool.name} logo`} />;
};

export default ToolLogo;
